"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialGoogleCDNValues = exports.GOOGLE_CDN = void 0;
exports.GOOGLE_CDN = "GOOGLE_CDN";
exports.initialGoogleCDNValues = {
    bucket_name: "",
    cdn_domain_name: "",
    service_account: {
        project_id: "",
        client_id: "",
        private_key: "",
        client_email: "",
    },
};
